// prettier-ignore
export default {
    "100": "Comment",
    "110": "Courriel",
    "120": "Graphisme",
    "140": "Outfolder"
}